<template>
    <div class="btn-group page-nav " role="group" >
        <router-link class="btn" :to="{ name: 'courses' }" :class="{ 'active': this.$route.name === 'courses' }" >
            <i class="fa-solid fa-right-left"></i> Locations
        </router-link>

        <router-link class="btn" :to="{ name: 'livraisons' }" :class="{ 'active': this.$route.name === 'livraisons' }" >
            <i class="fa-solid fa-hourglass-end"></i> Livraisons
        </router-link>

        <router-link class="btn" :to="{ name: 'reservations' }" :class="{ 'active': this.$route.name === 'reservations' || this.$route.name === 'reservations.single' }" >
            <i class="fa-solid fa-money-bill-transfer"></i> Demandes
        </router-link>
    </div>
</template>
